<template>
  <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
    <a-form-item ref="" label="运送方式：" name=""><p>快递</p></a-form-item>
    <a-form-item ref="name" label="模板名称" name="name">
      <a-input v-model:value="form.name" placeholder='请输入公司名称' />
    </a-form-item>
    <a-form-item ref="" label="按区域收费：" name="">
      <a-form-item ref="in_province_price" label="省内（广东省内）" name="in_province_price" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
        <a-row :gutter="10">
          <a-col :span="22">
            <a-input-number class="width100" v-model:value="form.in_province_price" :min='0' :precision='2' placeholder='请输入价格' />
          </a-col>
          <a-col :span="2">元</a-col>
        </a-row>
      </a-form-item>
      <a-form-item ref="out_province_price" label="省外（广东省外）" name="out_province_price" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
        <a-row :gutter="10">
          <a-col :span="22">
            <a-input-number class="width100" v-model:value="form.out_province_price" :min='0' :precision='2' placeholder='请输入价格' />
          </a-col>
          <a-col :span="2">元</a-col>
        </a-row>
      </a-form-item>
      <!-- <a-form-item ref="remote_area_price" label="偏远地区（新疆、西藏）" name="remote_area_price" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
        <a-row :gutter="10">
          <a-col :span="22">
            <a-input-number class="width100" v-model:value="form.remote_area_price" placeholder='请输入价格' />
          </a-col>
          <a-col :span="2">元</a-col>
        </a-row>
      </a-form-item> -->
    </a-form-item>
    
    <a-form-item ref="is_default" label="是否默认" name="is_default">
      <a-checkbox v-model:checked="form.is_default">系统默认</a-checkbox>
    </a-form-item>
        <a-form-item ref="is_full_package" label="是否满额包邮" name="is_default">
      <a-checkbox v-model:checked="form.is_full_package">是</a-checkbox>
        <a-form-item ref="" label="满额包邮" name="" v-if="form.is_full_package">
                 <a-input-number class="width100" v-model:value="form.full_package_amount" :min='0' :precision='2' placeholder='请输入价格(元)' />
      </a-form-item>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 4, offset: 4 }">
      <a-button type="primary" @click="onSubmit">
        保存
      </a-button>
    </a-form-item>
  </a-form>
</template>
<script>
  import { setDeliveryAdd, setDeliveryEdit } from "@/api/order";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
  let defForm = {
    name: '',
    in_province_price: '',
    out_province_price: '',
    // remote_area_price: '',
    is_default:0,
    is_full_package:0,
    full_package_amount:0
  }
  const form = ref(JSON.parse(JSON.stringify(defForm)));
  export default {
    components: {  },
    props: {
      formData:{
        type:Object
      },
    },
    name:'addFreight',
    setup(props,  { emit }) {
      const state = reactive({
        labelCol: { span: 4 },
        wrapperCol: { span: 18 },
        rules: {
          name: [
            { required: true, message: '请输入模板名称', },
          ],
          in_province_price: [
            { required: true, message: '请输入省内价格', },
          ],
          out_province_price: [
            { required: true, message: '请输入省外价格', },
          ],
          remote_area_price: [
            { required: true, message: '请输入偏远地区价格', },
          ]
        }
      });
      const ruleForm = ref()
      const onSubmit = () => {
        ruleForm.value.validate().then(async () => {
          let res
          const hide = message.loading('正在加载中...', 0);
          if (form.value.id) {
            res = await setDeliveryEdit(form.value).then(res => res.data).catch(error => error);
          } else {
            res = await setDeliveryAdd(form.value).then(res => res.data).catch(error => error);
          }
          if (iscode(res)) {
            message.success(res.msg);
            emit("onsubmit");
          }else {
            message.error(res.msg);
          }
          setTimeout(hide);
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      
      onMounted(() => {
        if(props.formData.id){
          form.value = props.formData
        }else{
          form.value = JSON.parse(JSON.stringify(defForm))
        }
      });
      return {
        ...toRefs(state),
        form,
        ruleForm,
        onSubmit
      };
    }
  }
</script>